



































































import { Component, Vue } from 'vue-property-decorator';
import { validationMixin } from 'vuelidate';
import vSelect from 'vue-select';
import { required } from 'vuelidate/lib/validators';
import secondaryNav from '@/components/navbars/secondary-nav.vue';
import OrgPicker from '@/components/orgPicker.vue';
import AdrLookup from '@/components/adr-lookup.vue';
import { Org, OrgsApi, Address } from '../../../api';
import Toast from '@/components/display/toast.vue';

@Component({
	components: {
		OrgPicker,
		secondaryNav,
		vSelect,
		AdrLookup,
	},
	validations: {
		form: {
			name: { required },
			adr: { address: { required } },
		},
	},
	mixins: [validationMixin],
})
export default class OrgCreate extends Vue {
	public form = {
		name: '',
		adr: { address: '', region: '' },
	};
	public place: any = null;
	public org: any = null;
	public region: any = null;

	public $bvToast: any;
	public loading = false;
	public submitStatus: 'ERROR' | 'PENDING' | 'OK' | null = null;
	private api: OrgsApi;

	constructor() {
		super();
		this.api = new OrgsApi();
	}

	public async onSubmit(e: Event) {
		e.preventDefault();
		this.$v.$touch();
		if (this.$v.$invalid) {
			this.submitStatus = 'ERROR';
			return;
		}
		this.submitStatus = 'PENDING';

		// const {orgId} = this.$route.params;
		// const {parentOrg, ...org} = this.form;
		const org = this.form;
		console.log(org);
		// org.parentId = parentOrg && parentOrg.id || '';
		org.address = this.form.adr.object;

		let response;
		try {
			response = await new OrgsApi().addOrg({ data: org });
		} catch (e) {
			const error = e.response.data.errors.name[0];
			new Toast().makeToast(error, 'Error Creating Org', 'danger', true);
			this.submitStatus = 'ERROR';
			return;
		}

		new Toast().makeToast('Org Created', 'Successfully', 'success');

		setTimeout(() => {
			this.submitStatus = 'OK';
			this.$router.push({ name: 'organisations.list' });
		}, 1000);
	}
}
